// extracted by mini-css-extract-plugin
export var chip = "_br-0";
export var filterDropdown = "_br-5";
export var filterItem = "_br-6";
export var icon = "_br-1";
export var removeButton = "_br-3";
export var removeIcon = "_br-4";
export var separator = "_br-2";